import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import BannerUpgrade from 'assets/images/banners/banner-upgrade.png';

import { BannerContent, ContentBody, ContentNews } from './styles';

type ParamsBody = {
    children: ReactNode;
}

type ParamsBanner = {
    bannerImg?: string;
    link: string;
    linkExternal?: boolean;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const ContentBodyPage = ({ children }: ParamsBody) => {
    return (
        <ContentBody>
            {children}
        </ContentBody>
    );
}

export const ContentNewsPage = ({ children }: ParamsBody) => {
    return (
        <ContentNews>
            {children}
        </ContentNews>
    );
}

export const Banner = ({ bannerImg = BannerUpgrade, link, linkExternal = false, onClick }: ParamsBanner) => {
    return (
        <BannerContent onClick={onClick}>
            {linkExternal ?
                <a href={link} target='blank'>
                    <img src={bannerImg} alt="banner" />
                </a>
                :
                <Link to={link}>
                    <img src={bannerImg} alt="banner" />
                </Link>
            }
        </BannerContent>
    );
}
